import CryptoJS from 'crypto-js';

//const secret_key = process.env.REACT_APP_CLAVE_PRIVADA_DECRIPT;

export const generateIv = () => {
	// Generar un IV aleatorio de 16 bytes (128 bits)
	const iv = CryptoJS.lib.WordArray.random(16);

	// Convertir el IV a Base64 para obtener el formato que necesitas
	const ivBase64 = CryptoJS.enc.Base64.stringify(iv);

	return ivBase64;
};

export const encryptAES256 = (value, iv) => {
	const secretKey = CryptoJS.enc.Utf8.parse(
		process.env.REACT_APP_CLAVE_PRIVADA_DECRIPT_PASS
	);
	const encrypted = CryptoJS.AES.encrypt(value, secretKey, {
		iv: CryptoJS.enc.Base64.parse(iv),
		padding: CryptoJS.pad.Pkcs7,
		mode: CryptoJS.mode.CBC,
	});

	return encrypted.toString();
};
